/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable prefer-template */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable @typescript-eslint/consistent-type-imports */
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ENVIRONMENTS } from '../app.config';
import { AppEnvConfig } from '../app.env.config';
import { NavigationHandlerService } from '../core/nav/navigation-handler.service';
import { FilterNavigation } from '../core/pipes/filter-navigation.pipe';
import { UserService } from '../core/user/user.service';
import { DividerOption } from '../shared-ui-refresh/divider/divider.model';
import { User } from '../shared/models/_models';
import { MenuItems, Menus, SelectedMenus } from './contracts/menu';
import { FnbIMenuResponse } from './FnBI.menu.json';
import { MenuService } from './menu.service';
import { AWSMenusResponseForLeftNav, MenusResponse } from './menus.json';
import { MenusValues } from './models/menu-values';
@Component({
    selector: 'nalco-menu',
    templateUrl: './menu.component.html',
    standalone: false
})
export class MenuComponent implements OnInit, OnDestroy {

    user: User;
    isNavigationDisabled = false;
    isExternalUser = false;
    menuList: MenusValues;
    useExternalNavigation = true;
    useLocalNavigation = true;
    private subscriptions: Subscription[] = [];
    leftTopNavigationItems: MenuItems[];
    leftBottomNavigationItems: MenuItems[];
    leftMidNavigationItems: MenuItems[];
    dividerCss: DividerOption
    isMobile = false;
    public isEnvisionMenuHide: boolean;
    isCredentialMenuHide: boolean;
    isClimateIntelligenceNavigation: string;
    isCrudeFlexEnabled: string;
    isFSQSEnabled: string;
    fnbIntelligenceUrl: string;
    waterIntelligenceUrl: string;
    isExpand: boolean;
    isNewUIEnabled: boolean;
    hideServicesForAWS = false;
    azure = 'azure';
    private readonly mobileBreakpoint = 720;

    constructor(
        private navService: NavigationHandlerService,
        private router: Router,
        private config: AppEnvConfig,
        private translate: TranslateService,
        private userService: UserService,
        private meta: Meta,
        private menuService: MenuService
    ) {
        this.isEnvisionMenuHide = JSON.parse(config.getEnv('isEnvisionMenuHide').toLowerCase());
        this.isCredentialMenuHide = config.getEnv('isCredentialMenuHide');
        this.isClimateIntelligenceNavigation = config.getEnv('isClimateIntelligenceNavigation').toString();
        this.isCrudeFlexEnabled = config.getEnv('isCrudeFlexEnabled').toString();
        this.isFSQSEnabled = config.getEnv('isFSQSEnabled');
        this.fnbIntelligenceUrl = config.getEnv('fnbIntelligenceUrl');
        this.waterIntelligenceUrl = config.getEnv('waterIntelligenceUrl');
        navService.navToggle$.subscribe(state => {
            this.isNavigationDisabled = state;
        });
        this.useExternalNavigation = false; //  environment.useExternalNavigation;
        this.useLocalNavigation = true; // environment.useLocalNavigation;
    }

    ngOnInit() {
        let FnBIMenuResponseCopy: Menus = JSON.parse(JSON.stringify(FnbIMenuResponse));
        this.subscriptions.push(this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            this.checkIsMobile();
            this.updateNavigationMenus();
        }));
        this.subscriptions.push(this.navService.updateLeftNav$.subscribe(async () => {
            this.getNavigationMenu();
        }));
        this.checkIsMobile();
        if (this.router.url.startsWith('/food-and-beverage-intelligence')) {
            this.updateNavigationMenus();
        } else {
            this.getNavigationMenu();
        }
        this.isNewUIEnabled = JSON.parse(this.config.getEnv('isNewUIEnabled').toString());

        // eslint-disable-next-line no-return-assign
        this.subscriptions.push(this.menuService.navExpand.subscribe(value =>
            this.isExpand = value
        ));
        this.dividerCss = {
            color: "#bac7d8",
            minLength: "30px",
            maxLength: "170px",
            isHorizontal: true
        }
        this.menuService.getUserIsCorporateORSite().subscribe((response) => {
            this.menuService.userScope = (response?.length ?? 0) > 1 ? 'corporate' : 'site';
            this.updateNavigationMenus();
        });
    }

    updateNavigationMenus() {
        let FnBIMenuResponseCopy: Menus = JSON.parse(JSON.stringify(FnbIMenuResponse));
        if (this.router.url.startsWith('/food-and-beverage-intelligence')) {
            if (this.menuService.userScope === 'corporate') {
                FnBIMenuResponseCopy.leftTopNavigation = FnBIMenuResponseCopy.leftTopNavigation.filter(menu => menu.name !== 'LEFT_NAV.TOP_PRIORITIES_NAV_LABEL_NAME');
            }
            this.navService.customizedMenus = JSON.parse(JSON.stringify(FnBIMenuResponseCopy));
            this.getNavigationMenu(this.navService.customizedMenus);
        } else {
            this.getNavigationMenu();
        }
    }

    private hideLeftSubMenuLinks() {

        const isGovInstance = this.config.getEnv('isGov');

        if (isGovInstance) {
            this.menuList.leftTopNavigation.forEach(menu => {
                if (menu.subNavigation && menu.subNavigation.length > 0) {
                    menu.subNavigation = menu.subNavigation.filter(item => item.isGOV === true);
                }
            });
        }

        if (this.isEnvisionMenuHide) {
            this.leftMidNavigationItems.forEach((s, index) => {
                if (s.label === 'LEFT_NAV.MAIN_NAV_TOOLS') {
                    this.leftMidNavigationItems.splice(index, 1);
                }
            });
        }
        if (!this.isCredentialMenuHide) {
            this.leftMidNavigationItems.forEach((s, index) => {
                if (s.label === 'LEFT_NAV.ADMIN_NAV_LABEL') {
                    s.subNavigation.forEach((d, i) => {
                        if (d.label === 'LEFT_NAV.SUBNAV_CREDENTIAL_MANAGEMENT.NAV_LABEL') {
                            this.leftMidNavigationItems[index].subNavigation.splice(i, 1)
                        }
                    })
                }
            });
        }
        if (this.isClimateIntelligenceNavigation === "false") {
            this.menuList.leftMidNavigation.forEach((s, index) => {
                if (s.label === 'LEFT_NAV.MAIN_NAV_LABEL') {
                    s.subNavigation.forEach((d, i) => {
                        if (d.label === 'LEFT_NAV.SUBNAV_CLIMATE.NAV_LABEL') {
                            this.menuList.leftMidNavigation[index].subNavigation.splice(i, 1)
                        }
                    })
                }
            });
        }
        if (this.isCrudeFlexEnabled === "false") {
            this.menuList.leftTopNavigation.forEach((s, index) => {
                if (s.label === 'LEFT_NAV.MAIN_NAV_LABEL') {
                    s.subNavigation.forEach((d, i) => {
                        if (d.label === 'LEFT_NAV.SUBNAV_CRUDE_FLEX_CORPORATION.NAV_LABEL') {
                            this.menuList.leftTopNavigation[index].subNavigation.splice(i, 1)
                        }
                    })
                }
            });
        }
        if (this.isFSQSEnabled === "false") {
            this.menuList.leftTopNavigation.forEach((s, index) => {
                if (s.label === 'LEFT_NAV.MAIN_NAV_LABEL') {
                    s.subNavigation.forEach((d, i) => {
                        if (d.label === 'LEFT_NAV.SUBNAV_FSQS.NAV_LABEL') {
                            this.menuList.leftTopNavigation[index].subNavigation.splice(i, 1)
                        }
                    })
                }
            });
        }
        if (this.config.getEnv("IsE3DChina") === "true") {
            this.menuList.leftMidNavigation.forEach((s, index) => {
                if (s.label === 'LEFT_NAV.MAIN_NAV_TOOLS') {
                    s.subNavigation.forEach((d, i) => {
                        if (d.label === 'LEFT_NAV.SUBNAV_ENVISION.CONFIGURATOR') {
                            this.menuList.leftMidNavigation[index].
                                subNavigation[i].link = 'Envision_Configurator_China';
                        }
                    })
                }
            });
        }
        if (this.config.getEnv("isE3DAccessRequestFormEnabled") === "false") {
            this.menuList.leftBottomNavigation.forEach((s, index) => {
                if (s.label === 'LEFT_NAV.MAIN_NAV_SUPPORT_SAFETY_INFO') {
                    s.subNavigation.forEach((d, i) => {
                        if (d.label === 'LEFT_NAV.ECOLAB3D_ACCESS_REQUEST_FOR_USERS') {
                            this.menuList.leftBottomNavigation[index].subNavigation.splice(i, 1)
                        }
                    })
                }
            });
        }
    }

    /**
      * @description Navigate to the functions based on the link availabitliy
      * @param SelectedMenus
      */


    menuItemClicked(event: SelectedMenus) {
        if (event.link) {
            this.navigateToLinks(event);
            // To check if the new UI for the expand is enabled or not 
            this.menuService.navExpand.next(JSON.parse(this.config.getEnv('isNewUIEnabled').toString()) && this.isExpand ? this.isExpand : false);
        } else {
            this.highlightMenus(event);
        }
    }

    /**
   * @description Navigate to the links based on the menus.json.ts
   * @param SelectedMenus
   */


    navigateToLinks(event: SelectedMenus) {
        if (event.link === '/admin-alarm') {
            sessionStorage.removeItem('UserLibSelection');
            sessionStorage.setItem('navigatedFromComponent', 'DashboardMenu');
            if (this.router.url === '/admin-alarm') {
                window.location.reload();
                sessionStorage.removeItem('UserLibSelection');
            }
        }
        if (event.link === '/water-track-iq-alarm') {
            sessionStorage.removeItem('UserLibSelection');
            sessionStorage.setItem('navigatedFromComponent', 'DashboardMenuAlarm');
            if (this.router.url === '/water-track-iq-alarm') {
                window.location.reload();
                sessionStorage.removeItem('UserLibSelection');
            }
        }
        let navigationLink = '';
        if (this.useExternalNavigation) {
            navigationLink = event.link;
        } else {
            // Need to discuss on this more on why this is used
            // if (event.link.substr(event.link.indexOf('#') > 2)) {
            //     navigationLink = event.link.substr(event.link.indexOf('#') + 1);
            // }
            navigationLink = event.link;
        }
        if (navigationLink.indexOf('settings') > -1) {

            if (event.siteId === undefined || event.siteId === null) {

                return false;
            } else if (event.siteId !== '') {

                this.routeToComponent(navigationLink, { queryParams: { siteId: event.siteId } });
            } else {

                this.routeToComponent(navigationLink);
            }
        } else {
            event.siteId = null;

            this.routeToComponent(navigationLink);
        }
        this.highlightMenus(event);
    }

    /**
   * @description Gets enabled Menus after the selections
   * @param SelectedMenus
   * @returns all the menus as per the roles
   */

    highlightMenus(event: SelectedMenus) {
        this.leftTopNavigationItems = this.menuService.enableSelection(event.text, this.menuList.leftTopNavigation);
        this.leftBottomNavigationItems = this.menuService.enableSelection(event.text, this.menuList.leftBottomNavigation);
        this.leftMidNavigationItems = this.menuService.enableSelection(event.text, this.menuList.leftMidNavigation);
    }




    desktopToggle() {
        this.meta.removeTag('name="viewport"');
        this.meta.addTag({ name: 'viewport', content: 'width=1600, , initial-scale=0.1' }, true);
    }


    private routeToComponent(navigationLink: string, queryParams?: any) {

        if (this.useExternalNavigation) {
            if (queryParams !== undefined) {
                window.location.href = navigationLink + '?siteId=' + queryParams.queryParams.siteId;
            } else {
                window.location.href = navigationLink;
            }
        } else {

            this.router.navigate([navigationLink], queryParams);
        }
    }


    filterItemsOfType() {
        this.leftTopNavigationItems = this.menuList.leftTopNavigation;
        this.leftBottomNavigationItems = this.menuList.leftBottomNavigation;
        this.leftMidNavigationItems = this.menuList.leftMidNavigation;
        // hide left nav for E3D China
        const userSettings = this.userService.getCurrentSettings();
        const isE3DChina = (this.config.getEnv("IsE3DChina") === "true") ? true : false;
        if (isE3DChina && (!userSettings.IsInternalUser)) {
            this.leftBottomNavigationItems = this.menuList.leftBottomNavigation.filter(x => x.name !== 'Training');
        }
        this.hideLeftSubMenuLinks();
    }

    filterByUserRole(role, navigationDetail, linksToExclude: string[]) {
        const userSettings = this.userService.getCurrentSettings();
        const isE3DChina = (this.config.getEnv("IsE3DChina") === "true") ? true : false;
        let navigationMenu = [];
        if (role !== null) {
            const pipe = new FilterNavigation();
            const IsInternalUser = userSettings ? userSettings.IsInternalUser : true;
            const UserRegion = userSettings ? userSettings.UserPreference.UserRegion : null;
            navigationMenu = pipe.transform(role, navigationDetail.leftNavigation, IsInternalUser, isE3DChina, linksToExclude, UserRegion);
            return navigationMenu;
        } else {
            return navigationMenu;
        }
    }

    menuFilterByUserRole(role, navigationDetail, linksToExclude: string[]) {
        const userSettings = this.userService.getCurrentSettings();
        const isE3DChina = (this.config.getEnv("IsE3DChina") === "true") ? true : false;
        let navigationMenu = [];
        if (role !== null) {
            const pipe = new FilterNavigation();
            const IsInternalUser = userSettings ? userSettings.IsInternalUser : true;
            const UserRegion = userSettings ? userSettings.UserPreference.UserRegion : null;
            navigationMenu = pipe.transform(role, navigationDetail, IsInternalUser, isE3DChina, linksToExclude, UserRegion);
            return navigationMenu;
        } else {
            return navigationMenu;
        }
    }

    getNavigationMenu(menuItems?: Menus) {
        const role = this.userService.getUserRole();
        const userPermissions = [];
        if (role !== null) {
            role.forEach(function (s) {
                userPermissions.push(s.PermissionId.toString());
            })
        }

        this.hideServicesforAWSInstance();
        const env = environment.environment;
        const MenuItemsArray = menuItems && Object.keys(menuItems).length ? menuItems : (this.hideServicesForAWS ? JSON.parse(JSON.stringify(AWSMenusResponseForLeftNav)) : JSON.parse(JSON.stringify(MenusResponse)));
        const userSettings = this.userService.getCurrentSettings();

        if (this.hideServicesForAWS && !userSettings.IsInternalUser) {
            this.menuList = MenuItemsArray;
            this.menuList.leftMidNavigation.forEach((s => {
                if (s.label === 'LEFT_NAV.MAIN_NAV_TOOLS') {
                    s.subNavigation.forEach((d, i) => {
                        if (d.isInternalUser) {
                            s.subNavigation.splice(i, 1);
                        }
                    })
                }
            }))
        }
        else if (!this.hideServicesForAWS && env === ENVIRONMENTS.prod) {
            this.menuList = MenuItemsArray;
            this.menuList.leftMidNavigation.forEach((s => {
                if (s.label === 'LEFT_NAV.MAIN_NAV_TOOLS') {
                    s.subNavigation.forEach((d, i) => {
                        if (d.hideInProd) {
                            s.subNavigation.splice(i, 1);
                        }
                    })
                }
            }))
        }
        else {
            this.menuList = MenuItemsArray;
        }
        const linksToExclude = this.getLinksToExclude();
        this.menuList.leftTopNavigation = this.menuFilterByUserRole(userPermissions, MenuItemsArray.leftTopNavigation, linksToExclude)
        this.menuList.leftMidNavigation = this.menuFilterByUserRole(userPermissions, MenuItemsArray.leftMidNavigation, linksToExclude)
        this.menuList.leftBottomNavigation = this.menuFilterByUserRole(userPermissions, MenuItemsArray.leftBottomNavigation, linksToExclude)
        const isE3DChina = (this.config.getEnv("IsE3DChina") === "true") ? true : false;
        if (isE3DChina) {
            this.menuList.leftTopNavigation.forEach(nav => {
                const hasRI = nav.subNavigation.find(item => item.breadcrumb === "Recycle Intelligence");
                if (hasRI) {
                    nav.subNavigation.push({
                        breadcrumb: "Digital Intelligence",
                        hover: "Digital Intelligence",
                        isSelected: false,
                        label: "数智汇",
                        labelMobile: "数智汇",
                        link: "/digital-intelligence",
                        text: '数智汇',
                        name: "Navigation - Main - Digital Intelligence"
                    })
                    nav.subNavigation = nav.subNavigation.filter(item => item.breadcrumb !== "Recycle Intelligence")
                }

            })
        }
        this.filterItemsOfType();

        if (menuItems && Object.keys(menuItems).length) {
            return;
        } else {
            this.sortMenuItems();
        } // 300ms delay to give files time to load
    }

    /**
   * @description Gets list of links to exclude
   * @returns string of links to exclude
   */
    getLinksToExclude(): string[] {
        const isNewFiRefreshEnabled: boolean = this.config.getEnv('isNewFiRefreshEnabled') === "true";
        const excludeLinks = isNewFiRefreshEnabled ? ['/financial-impact/admin'] : [];

        return excludeLinks;
    }

    /**
     * @description Routes where the narrow-window (< 720px) mobile layout is enabled:
     * the DCI routes plus /home. Other routes keep the desktop layout on narrow windows.
     */
    private isMobileScopedRoute(): boolean {
        const url = this.router.url;
        return url.startsWith('/legionella-test-results')
            || url.startsWith('/upload-reports-and-plans')
            || url.startsWith('/coolant-health-iq')
            || url.startsWith('/home');
    }

    /**
     * @description Recomputes the mobile state from device user-agent (all routes) OR viewport
     * width (< 720px, scoped routes only) so the left nav collapse is route-scoped.
     */
    private checkIsMobile(): void {
        const isMobileDevice = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
        this.isMobile = isMobileDevice || (this.isMobileScopedRoute() && window.innerWidth < this.mobileBreakpoint);
    }

    @HostListener('window:resize')
    onResize(): void {
        this.checkIsMobile();
    }

    /************ Analytics Listener ************/
    @HostListener('click', ['$event'])
    onClick(event) {
        if (event.target.className.indexOf !== undefined && this.isMobile
            && (event.target.className.indexOf('submenu-margin') > 0 ||
                event.target.className.indexOf('singlemenu') > -1)) {
            this.isExpand = false;
        }
    }

    /**
  * @description It Will expand the left navigation bar 
  * Passing values with the help of behaviour subject
  */

    expandNavBar(): void {
        this.isExpand = !this.isExpand
        this.menuService.navExpand.next(this.isExpand);
    }

    hideServicesforAWSInstance() {
        const cloud = environment.cloudEnv;
        if (cloud.toLowerCase() === this.azure) {
            this.hideServicesForAWS = false;
        }
        else {
            this.hideServicesForAWS = true;
        }
    }

    ngOnDestroy() {
        // prevent memory leak when component is destroyed
        this.subscriptions.forEach(s => s.unsubscribe());
    }
    private sortMenuItems(): void {
        if (this.menuList) {
            // Sort leftTopNavigation
            if (this.menuList.leftTopNavigation) {
                this.menuList.leftTopNavigation = this.sortMenuItemsByLabel(this.menuList.leftTopNavigation);
            }
            // Sort leftMidNavigation items where label includes 'tools'
            if (this.menuList.leftMidNavigation) {
                this.menuList.leftMidNavigation = this.menuList.leftMidNavigation.map(item => {
                    if (item.name?.toLowerCase().includes('tools')) {
                        return {
                            ...item,
                            subNavigation: item.subNavigation ? this.sortMenuItemsByLabel(item.subNavigation) : item.subNavigation
                        };
                    }
                    return item;
                });
            }
        }
    }
    private stripHtmlTags(text: string): string {
        if (!text) { return ''; }
        return text.replace(/<[^>]*>/g, '').trim();
    }
    private sortMenuItemsByLabel(menuItems: MenuItems[]): MenuItems[] {
        if (!menuItems || menuItems.length === 0) { return menuItems; }

        return menuItems.sort((a, b) => {
            // Use text property if it exists, otherwise fall back to label
            const rawTextA = a.text || a.label || '';
            const rawTextB = b.text || b.label || '';

            // Strip HTML tags and normalize for comparison
            const textA = this.stripHtmlTags(this.translate.instant(rawTextA)).toLowerCase().trim();
            const textB = this.stripHtmlTags(this.translate.instant(rawTextB)).toLowerCase().trim();

            // Handle empty strings by putting them at the end
            if (!textA && !textB) { return 0; }
            if (!textA) { return 1; }
            if (!textB) { return -1; }

            return textA.localeCompare(textB, undefined, {
                numeric: true,
                sensitivity: 'base',
                ignorePunctuation: true
            });
        }).map(item => {
            // If the item has subNavigation, sort it recursively
            if (item.subNavigation && item.subNavigation.length > 0) {
                item.subNavigation = this.sortMenuItemsByLabel(item.subNavigation);
            }
            return item;
        });
    }
}
